// extracted by mini-css-extract-plugin
module.exports = {"root":"paydata_root_3fgGf","title":"paydata_title_LGSjj"};